import { render, staticRenderFns } from "./edit-article.vue?vue&type=template&id=7c4ac1fb&scoped=true&"
import script from "./edit-article.vue?vue&type=script&lang=ts&"
export * from "./edit-article.vue?vue&type=script&lang=ts&"
import style0 from "./edit-article.vue?vue&type=style&index=0&id=7c4ac1fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4ac1fb",
  null
  
)

export default component.exports